export default __webpack_public_path__ + "static/media/gear.9b5e0f84.svg";